angular.module('TetherApp').directive('tetherForm', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherForm.html'
    }
});
